import { axiosInstance } from "../../../util/axios";
import { cncBaseUrlSelector, getCncAuthToken } from "../../../Api/ApiHelper";
import { formatWithPlaceholders } from "../../../util/utils";

export const fetchCncVoucherReport = ({ orderNumber, emailId }) => {
  const baseUrl = cncBaseUrlSelector();
  const url = formatWithPlaceholders(
    `${baseUrl}${process.env.REACT_APP_RETRIEVE_CNC_VOUCHER_API_URL}`,
    orderNumber,
    emailId
  );
  return axiosInstance.get(url, {
    headers: {
      Authorization: `Bearer ${getCncAuthToken()}`,
      Accept: "application/json",
    },
  });
};

export const resendCncVoucher = ({ postBody }) => {
  const {
    message,
    email,
    name,
    templateId,
    voucherNos,
    voucherExpiry,
    subject,
    weborderNumber,
    voucherIssuedStoreLocation,
    assigned_date,
    mobile_number,
    order_value,
  } = postBody;
  const baseUrl = cncBaseUrlSelector();
  const url = `${baseUrl}${process.env.REACT_APP_CNC_VOUCHER_RESEND_API_URL}`;
  return axiosInstance.post(
    url,
    {
      message,
      target_emails: email,
      target_name: name,
      template_id: templateId,
      voucher_nos: voucherNos,
      voucher_expiry: voucherExpiry,
      subject,
      weborder_number: weborderNumber,
      voucher_issued_store_location: voucherIssuedStoreLocation,
      status: "published",
      voucher_assigned_date: assigned_date,
      is_resent: true,
      mobile_number,
      order_value,
    },
    {
      headers: {
        Authorization: `Bearer ${getCncAuthToken()}`,
        Accept: "application/json",
      },
    }
  );
};
